module.exports = __webpack_public_path__ + "img/sofa.5f92aef3.png";